export default "__VITE_ASSET__BCpubeZX__"